import Groupings from 'Common/Constants/Groupings';

const isYearFixed = grouping => false;

export default isYearFixed;
